<template>
  <div class="ConfirmationBanner">
    <div class="container">
      <div class="img_holder">
        <app-icon :name="iconName"/>
      </div>

      <h2 class="title">
        {{ title }}
      </h2>

      <p class="description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'confirmation-banner',

    props: {
      iconName: {
        type: String,
        required: true
      },

      title: {
        type: String,
        required: true
      },

      description: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .ConfirmationBanner {
    color: #fff;
    font-size: .21rem;
    background-color: #0066a1;
    background-repeat: repeat-x;
    background-image: linear-gradient(to bottom right, #003655 0, #0066a1 50%, #0096ee 100%);

    .container {
      display: flex;
      flex-direction: column;
      text-align: center;
      padding: .3rem;
      font-weight: 700;

      .icon-error {
        width: .5rem;
        height: .5rem;
      }

      .title {
        margin-top: .2rem;
        font-size: .26rem;
        line-height: 1;
      }

      .description {
        font-size: .16rem;
        line-height: 1.4;
        font-weight: 400;
      }

      @include media(tablet) {
        width: 4.97rem;
      }
    }
  }
</style>
